class MarkerOverlay {
  constructor(position, content) {
    this.overlay_ = null;
    this.containerDiv = null;
    this.listeners = [];
    this.content = content;
    this.display = true;
    this._cachedLatLng = null; // Reusable LatLng to avoid allocation per draw()
    this.createOverlay(position, content);
  }

  createOverlay(position, content) {
    try{
      this.overlay_ = new google.maps.OverlayView(); // eslint-disable-line no-undef
      this.overlay_.onAdd = this.onAdd.bind(this);
      this.overlay_.draw = this.draw.bind(this);
      this.overlay_.onRemove = this.onRemove.bind(this);
      this.overlay_.onMove = this.onMove.bind(this);
      this.overlay_.onChangeLabel = this.onChangeLabel.bind(this);
      this.overlay_.onDisplayObject = this.onDisplayObject.bind(this);
  
      this.overlay_.position = position;
      content.classList.add("popup-bubble");
  
      // This zero-height div is positioned at the bottom of the tip.
      this.containerDiv = document.createElement("div");
      this.containerDiv.classList.add("popup-container");
      this.containerDiv.appendChild(content);
  
      // Optionally stop clicks, etc., from bubbling up to the map.
      //google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv);// eslint-disable-line no-undef
    }catch(e){
      console.log('error to load Marker Overlay', e)
    }
  }

  /** Called when the popup is added to the map. */
  onAdd() {
    try{
      if(this.containerDiv){
        const panes = this.overlay_.getPanes();
        panes.overlayMouseTarget.appendChild(this.containerDiv);
        /* Add the element to the pane.
          MapPanes.mapPane (Level 0)
          MapPanes.overlayLayer (Level 1)
          MapPanes.markerLayer (Level 2)
          MapPanes.overlayMouseTarget (Level 3)
          MapPanes.floatPane (Level 4)
        */
        this.cancelEvents();
      }
    }catch(e){
      console.log('error to load Marker Overlay', e)
    }
  }

  /** Called when the popup is removed from the map. */
   onRemove() {
    if (this.containerDiv && this.containerDiv.parentElement) {
      this.containerDiv.parentElement.removeChild(this.containerDiv);
      this.containerDiv = null;
    }

    // Clean up native DOM listeners
    for (let i = 0; i < this.listeners.length; i++) {
      this.listeners[i]();
    }
    this.listeners.length = 0;
    this._cachedLatLng = null;
  }

  onMove(position, isNewClass = false){

    if(this.overlay_){
      this.overlay_.position = position;
      this._cachedLatLng = null; // Invalidate cache on position change
      this.draw()

      if(isNewClass){
        this.content.classList.remove("popup-bubble");
        this.content.classList.add("popup-bubble-moved");
      }else{
        this.content.classList.add("popup-bubble");
        this.content.classList.remove("popup-bubble-moved");
      }
    }
  }

    onChangeLabel(label, idsGroupLabel = null, callbackEvent = null, innerText = "View Detail..."){
        if(this.containerDiv){
            this.containerDiv.children[0].innerHTML = label;
            if(idsGroupLabel){
                let button = document.createElement("a");
                button.innerText = innerText;
                button.classList.add("buttonModalGroupsText");
                button.addEventListener("click", () => {
                    callbackEvent(idsGroupLabel)
                });
                this.containerDiv.children[0].appendChild(button);
            }
        }
    }

    onDisplayObject(valueDisplay, map){
        if(this.display == valueDisplay) return;

        this.display = valueDisplay;
        //this.containerDiv.style.display = valueDisplay;
        this.overlay_.setMap(valueDisplay ? map : null);
        if(valueDisplay){
            this.containerDiv = document.createElement("div");
            this.containerDiv.classList.add("popup-container");
            this.containerDiv.appendChild(this.content);
        }
        this.draw();
    }

    onDisplay(valueDisplay){
        this.display = valueDisplay;
    }

  draw() {
    
    if(!this.display || !this.containerDiv) return;

    const overlayProjection = this.overlay_.getProjection();
    if(!overlayProjection) return

      // Reuse cached LatLng to avoid allocation per frame
      if (!this._cachedLatLng) {
        this._cachedLatLng = new google.maps.LatLng(this.overlay_.position.lat(), this.overlay_.position.lng()); // eslint-disable-line no-undef
      }
      const divPosition = overlayProjection.fromLatLngToDivPixel(this._cachedLatLng);
    
    const isVisible =
        Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000;

    if (isVisible) {
      // Use transform instead of left/top to avoid layout shifts (CLS)
      // translate3d promotes to compositor layer — no layout recalculation
      this.containerDiv.style.transform = `translate3d(${divPosition.x}px, ${divPosition.y}px, 0)`;
    }

    const display = isVisible ? "block" : "none";
    if (this.containerDiv.style.display !== display) {
      this.containerDiv.style.display = display;
    }
  }

  setMap(map) {
    if(this.overlay_){
      this.overlay_.setMap(map);
    }
  }

  cancelEvents() {
    const events = ['mousemove', 'mouseover',
      'mouseout', 'mouseup',
      'touchstart', 'touchend',
      'touchmove', 'dblclick', 'contextmenu'];
    // Use native DOM listeners instead of google.maps.event to reduce overhead
    // (9 lightweight native listeners vs 9 heavy GMaps event wrappers per overlay)
    const handler = (e) => {
      e.stopPropagation();
    };
    for (let i = 0; i < events.length; i++) {
      this.containerDiv.addEventListener(events[i], handler);
      // Store cleanup function for onRemove
      this.listeners.push(() => this.containerDiv?.removeEventListener(events[i], handler));
    }
  }
}

export default MarkerOverlay